import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { OnScreenMessageService } from '../services/onScreenMessage/onScreenMessage.sevice';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private onScreenMessageService: OnScreenMessageService, private translate: TranslateService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    if (localStorage.getItem('isAutenticatedUser') == 'true') {
      return true;
    } else {
      this.router.navigateByUrl('/');
      this.translate.get('SCV.LOG.MSGSESSIONTIMEOUT').subscribe((value) => {
        this.onScreenMessageService.Error(this.translate.instant(value));
        localStorage.clear();
        return false;
      });

    }

  }
}
